import React, { Component } from 'react';
import Message from './ValidationMessage';

export class CurrencyLabelField extends Component {
  numberBetween(min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return (value, previousValue, allValues) => {
      return (value < Number(min)) ? Number(min) : (value > Number(max)) ? Number(max) : Number(value);
    }
  }

  render() {
    let { intl, translation, input, required,currency, label, disabled, placeholder, id, meta: { touched, error, warning } } = this.props;
    if (intl && translation) {
      const labelObj = translation.label;
      const placeholderObj = translation.placeholder;
      if(labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
      if(placeholderObj && placeholderObj.message) {
        placeholder = intl.formatMessage(placeholderObj.message, placeholderObj.params);
      }
    }
    
    let showError = touched && error ? 'error' : '';
    
    return (
      <div className={`${required && 'required'} field ${showError}`}>
        <label>{label}</label>
        <div className="ui left action input field">
          <div className="ui basic white button">{currency}</div>
          <input {...input} type='number' placeholder={placeholder} disabled={disabled} id={id}/>
          <Message show={touched} message={error} />
          <Message show={touched} message={warning} />
        </div>
      </div>
    );
  }
}
export function CURRENCY({ allowNegative = false, currencyCode = 'USD', locales = [] } = {}) {
  return (value) => {
    if (value === '') {
      return Number(value);
    }
    const amount = allowNegative ? Number(value) : Math.abs(value);
    const opts = {
      style: 'currency',
      currencyDisplay: 'code',
      useGrouping: false,
      currency: currencyCode.toUpperCase(),
    };
    const formattedNumber = new Intl.NumberFormat(locales, opts).format(amount);
    return Number(formattedNumber.replace(currencyCode, ''));
  };
}

export const asCurrency = (amount) => {
  return CURRENCY()(amount);
};
